import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  OnChanges,
} from '@angular/core';
import {
  FormGroup,
  FormControl,
  Validators,
} from '@angular/forms';
import {
  MessageType,
  ToasterService,
  Institution,
  SpinnerService,
  PersistenceAction,
  SurveyQuestion,
  InstitutionType,
  Message, EduFamilySurvey, DataType
} from 'projects/shared-lib/src/public-api';
import { Router, ActivatedRoute } from '@angular/router';
import { InstitutionService } from '../../core/services/institution.service';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { EduFamilySurveyService } from '../../core/services/edu-family-survey.service';
import { MatDialog } from '@angular/material/dialog';
import { HouseholdIdModal } from '../household-id-modal/household-id-modal.component';
import { ThemeService } from '../../core/services/theme.service';
import { LocalStorageUtil } from '../../shared/utils/local-storage.util';
import { DataStoreService } from '../../core/services/data-store.service';
import { TranslateLanguage } from '../../shared/model/translate-language.model';
import { TranslateService } from '@ngx-translate/core';
import { HouseholdConfirmationdModal } from '../household-confirmation-modal/household-confirmation-modal.component';
import { ParagraphUtil } from '../../shared/utils/paragraph.util';
import { EncryptionUtil } from '../../shared/utils/encryption-util';
import { ExistingHouseholdModalComponent } from '../existing-household-modal/existing-household-modal.component';

@Component({
  selector: "education-survey",
  templateUrl: './education-survey.component.html',
  styleUrls: ['education-survey.component.css'],
})
export class EducationSurveyComponent implements OnInit, OnChanges, OnDestroy {
  public afterHourCareType: number = InstitutionType.AFTER_HOUR_CARE;
  public membersForms: FormGroup[] = [];
  public preferredDistricControl: FormControl;
  public householdIdControl: FormControl;
  @Input() emailControl: FormControl;
  @Input() needEmail;
  @Input() surveys: EduFamilySurvey[];

  public preferredInstution: Institution;
  public selectedDistricts: Institution[] = [];
  public districts: Institution[] = [];
  public genders: DataType[] = [];
  public races: DataType[] = [];
  public ethnicities: DataType[] = [];
  public questions: SurveyQuestion[];

  private subscriptions: Subscription[] = [];
  private lang: string;
  private language: TranslateLanguage;
  private allLang: TranslateLanguage[] = [];
  private deletedSurveys: FormGroup[] = [];

  private isUpdate = false;
  private skipValidation = false;
  private categoryName: string = 'edu-family';

  constructor(
    public localStorageUtil: LocalStorageUtil,
    public paragraphUtil: ParagraphUtil,
    private toasterService: ToasterService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public institutionService: InstitutionService,
    private spinnerService: SpinnerService,
    private eduFamilyService: EduFamilySurveyService,
    private dialog: MatDialog,
    private dataStoreService: DataStoreService,
    private translateService: TranslateService,
    private themeService: ThemeService,
    private encryptionUtil: EncryptionUtil
  ) {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.lang = params['lang'] ? params['lang'] : 'en';
      if (this.language) {
        this.selectLanguageQuestions();
      }
    });


    this.translateService.onLangChange.subscribe((event) => {
      this.lang = event.lang ? event.lang : 'en';
      if (this.lang) {
        this.selectLanguageQuestions();
      }
    });
  }

  ngOnInit() {
    this.loadFormCatalogsData();
    this.householdIdControl = new FormControl('', [Validators.required]);
    this.preferredDistricControl = new FormControl('', [Validators.required]);
    let firstForm = this.newStudentForm();
    this.membersForms.push(firstForm);
    this.addListenerToSingleControl(firstForm);
    this.dataStoreService.languages$.subscribe((langs) => {
      this.allLang = langs;
      this.selectLanguageQuestions();
    });


    this.localStorageUtil.preferredInstitutionChanged$.subscribe(
      (institution) => {
        this.preferredInstution = institution;
        if (this.preferredInstution && this.districts.length > 0) {
          this.preferredDistricControl.setValue(this.preferredInstution.id);
          if (this.membersForms.length === 1 && this.localStorageUtil.getIsInstitutionURL(this.categoryName)) {
            switch (this.preferredInstution.institutionTypeId) {
              case InstitutionType.SCHOOL_DISTRICT:
                this.membersForms[0].controls['districtControl'].setValue(this.preferredInstution.id);
                break;
            }
          }
        }
      }
    );

    this.preferredDistricControl.valueChanges.subscribe(val => {
      this.updatePreferredDistrict();
    });

  }

  ngOnChanges(changes) {
    if(changes && changes.surveys && changes.surveys.currentValue && changes.surveys.currentValue.length){
      this.mapSurveyControls(changes.surveys.currentValue);
    }
  }

  ngOnDestroy() {
    if (this.subscriptions.length) {
      this.subscriptions.forEach((s) => {
        s.unsubscribe()});
    }
  }

  public getListOfSchools(distId: number): any[] {
    if (!distId) return [];
    let selectedDistrict = this.districts.find((d) => d.id == distId);
    if (selectedDistrict) return selectedDistrict.facilities;
    else [];
  }

  public getListOfGrades(distId: number, schoolId: number): any[] {
    if (!schoolId || !distId) return [];
    let selectedDistrict = this.districts.find((d) => d.id == distId);
    let selectedSchool = selectedDistrict.facilities.find(
      (f) => f.id == schoolId
    );
    if (selectedSchool) return selectedSchool.units;
    else [];
  }

  public showPreferredDistrictOpt(): boolean {
    this.selectedDistricts = [];
    let result = false;
    this.membersForms.forEach((m) => {
      const districtInstId = m.controls['districtControl'].value;
      const afterCareInstId = m.controls['afterHourCareDistrictControl'].value;
      const isDistrictNotFound =  !this.selectedDistricts.find((d) => d.id === districtInstId);
      const isAfterCareNotFound = !this.selectedDistricts.find((d) => d.id === afterCareInstId);

      if (m.controls['districtControl'].valid &&
        districtInstId !== '' &&
        isDistrictNotFound) {
        this.selectedDistricts.push(this.districtById(districtInstId));
      }

      if (m.controls['afterHourCareDistrictControl'].valid &&
        afterCareInstId !== '0' &&
        afterCareInstId !== '' &&
        afterCareInstId !== null &&
        isAfterCareNotFound) {
        const foundAfterCareInst = this.institutionService.allInstutions$.value.find((d) => d.id === afterCareInstId);
        this.selectedDistricts.push(foundAfterCareInst);
      }
    });

    const filteredInstitutions = this.selectedDistricts.filter((i) => i.hasPublishedPathwayTrees);
    if (filteredInstitutions.length >= 2) {
      result = true;
    }
    return result;
  }

  public addHouseholdMember() {
    let newForm = this.newStudentForm();
    this.membersForms.push(newForm);
    this.addListenerToSingleControl(newForm);
  }

  public saveForms() {
    const houseHoldId = this.localStorageUtil.getHouseHoldId(this.categoryName)
      ? this.localStorageUtil.getHouseHoldId(this.categoryName)
      : this.generateId();
    this.surveys = this.buildSurveys(houseHoldId);
    let preferredDistrict = this.institutionService.allInstutions$.value.find(
      (i) => i.id == this.preferredDistricControl.value
    );
    this.spinnerService.show();

    this.subscriptions.push(
      this.eduFamilyService
        .saveSurveys({ eduFamilySurveys: this.surveys, skipUniqueHouseHold: this.skipValidation })
        .pipe(finalize(() => this.spinnerService.hide()))
        .subscribe(
          (res) => {
            if (res.operationSuccess) {
              this.localStorageUtil.saveHouseHoldId(this.categoryName,houseHoldId);
              if (preferredDistrict) {
                this.localStorageUtil.savePreferedInstitution(this.categoryName,
                  preferredDistrict
                );
                this.themeService.setInstitution(preferredDistrict);
                this.localStorageUtil.savePreferedInstitution(this.categoryName,preferredDistrict);
              }

              this.showHouseIdModal(houseHoldId, this.surveys);
            }  else if (res.messages.length > 0) {
              let householdList = res.messages.filter(m => m.type == MessageType.HOUSEHOLD);
              if(householdList.length){
                this.showExistingHouseholdModal(householdList);
              }
              else {
                this.toasterService.show(
                  MessageType.SYSTEM_ERROR,
                  res.messages[0].text
                );
              }
            } else {
              this.toasterService.show(
                MessageType.SYSTEM_ERROR,
                'System error'
              );
            }
          },
          (err) => this.toasterService.show(MessageType.SYSTEM_ERROR, err)
        )
    );
  }

  public deleteForm(index) {
    let deletedSurvey = this.membersForms.splice(index, 1);
    if (
      deletedSurvey[0].controls['idControl'] &&
      deletedSurvey[0].controls['idControl'].value > 0
    ) {
      this.deletedSurveys.push(deletedSurvey[0]);
      this.updatePreferredDistrict();
    }
  }

  private onError(error: string) {
    this.toasterService.show(MessageType.SYSTEM_ERROR, error);
  }

  private validForm(): boolean {
    let formsValid = true;
    this.membersForms.forEach((form) => {
      form.markAllAsTouched();
      if (form.invalid) {
        formsValid = false;
      };
    });
    if (!formsValid) {
      this.toasterService.show(
        MessageType.WARNING,
        'Please complete all required fields of the survey.'
      );
      return false;
    }

    if (this.showPreferredDistrictOpt()) {
      if (this.preferredDistricControl.invalid) {
        this.preferredDistricControl.markAllAsTouched();
        this.toasterService.show(
          MessageType.WARNING,
          'Please select a default district.'
        );
        return false;
      }
    } else {
      this.preferredDistricControl.setValue(this.preferredInstution.id);
    }
    if(this.emailControl.value != null){
      this.emailControl.setValue(this.emailControl.value.trim());
    }
    if(this.emailControl.invalid && this.needEmail){
      this.emailControl.markAllAsTouched();
      this.toasterService.show(
        MessageType.WARNING,
        'Please enter a valid email.'
      );
      return false;
    }
    return true;
  }

  private selectLanguageQuestions() {
    this.language = this.allLang.find(
      (l) => l.languageCode.toUpperCase() === this.lang.toUpperCase()
    );
    let category = this.language
      ? this.language.categories.find((c) => c.description == 'EDU-Family')
      : null;
    this.questions = category ? category.surveyQuestions : [];
    if (this.questions == []) {
      this.lang = 'en';
      this.selectLanguageQuestions();
    }
  }

  private updatePreferredDistrict() {
    this.selectedDistricts = [];
    this.membersForms.forEach((m) => {
      const districtInstId = m.controls['districtControl'].value;
      const afterCareInstId = m.controls['afterHourCareDistrictControl'].value;
      const isDistrictNotFound =  !this.selectedDistricts.find((d) => d.id === districtInstId);
      const isAfterCareNotFound = !this.selectedDistricts.find((d) => d.id === afterCareInstId);

      if (m.controls['districtControl'].valid &&
        districtInstId !== '' &&
        isDistrictNotFound) {
        this.selectedDistricts.push(this.districtById(districtInstId));
      }
      if (m.controls['afterHourCareDistrictControl'].valid &&
        afterCareInstId !== '0' &&
        afterCareInstId !== '' &&
        afterCareInstId !== null &&
        isAfterCareNotFound) {
        const foundAfterCareInst = this.institutionService.allInstutions$.value.find((d) => d.id === afterCareInstId);
        this.selectedDistricts.push(foundAfterCareInst);
      }
    });
    if (this.selectedDistricts.length > 0) {
      const filteredInstitutions = this.selectedDistricts.filter((i) => i.hasPublishedPathwayTrees);
      if (filteredInstitutions.length > 1) {
        this.preferredInstution = this.institutionService.allInstutions$.value.find((i) => i.id === this.preferredDistricControl.value);
      } else if (filteredInstitutions.length === 1) {
        this.preferredInstution = this.institutionService.allInstutions$.value.find((i) => i.id === filteredInstitutions[0].id);
      } else {
        this.preferredInstution =  this.institutionService.allInstutions$.value.find((i) => i.isDefault);
        if(this.preferredDistricControl.value != this.preferredInstution.id){
          this.preferredDistricControl.setValue(this.preferredInstution.id);
        }
      }
      this.membersForms.forEach(m => {
        m.controls['firstNameControl'].clearValidators();
        m.controls['lastNameControl'].clearValidators();

        var validator = [ Validators.pattern('^[a-zA-Z ]*$')];
        m.controls['firstNameControl'].setValidators(validator);
        m.controls['lastNameControl'].setValidators(validator);
        m.controls['firstNameControl'].updateValueAndValidity();
        m.controls['lastNameControl'].updateValueAndValidity();
        m.controls['needNameControl'].updateValueAndValidity();
      });
    }
  }

  private showExistingHouseholdModal(ids: Message[]){
    const dialogRef = this.dialog.open(ExistingHouseholdModalComponent, {
      data: {
        messageIds: ids,
      },
      width: '33rem',
      autoFocus: false,
      maxHeight: '90vh',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if(result == null){
        return;
      }
      if (result != false) {
        this.localStorageUtil.saveHouseHoldId(this.categoryName,result);
      }
      this.skipValidation = true;
      this.saveForms();
    });

  }

  private showHouseIdModal(houseHoldId: string, surveys: EduFamilySurvey[]) {
    let needREDCap = false;
    this.updatePreferredDistrict();

    const dialogRef = this.dialog.open(HouseholdIdModal, {
      data: {
        houseHoldId: houseHoldId,
        surveys: surveys,
        districts: this.districts,
      },
      width: '33rem',
      autoFocus: false,
      maxHeight: '90vh',
    });

    dialogRef.afterClosed().subscribe((result) => {
      const queryParams = { lang: this.translateService.currentLang };
      const inst = this.localStorageUtil.getPreferedInstitution(this.categoryName);
      const url = `edu-family/institutions/${inst.id}/guidelines`;
      this.router.navigate([url], { queryParams });
    });
  }

  public showConfimationModal() {
    // Validate form before show the confirmations modal
    if (!this.validForm()) return;

    const dialogRef = this.dialog.open(HouseholdConfirmationdModal, {
      width: '33rem',
      autoFocus: false,
      maxHeight: '90vh',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result == true) {
        this.saveForms();
      }
    });
  }

  private mapSurveyControls(students: EduFamilySurvey[]) {
    this.membersForms = this.membersForms.slice(0,1);
    students.forEach((student, index) => {
      if (index === 0) {
        this.membersForms[0].controls['districtControl'].setValue(
          student.institutionId
        );
        this.membersForms[0].controls['schoolControl'].setValue(
          student.facilityId
        );
        this.membersForms[0].controls['afterHourCareDistrictControl'].setValue(
          student.afterHourInstitutionId  ? student.afterHourInstitutionId : '0'
        );
        this.membersForms[0].controls['gradeControl'].setValue(
          student.unitId
        );
        this.membersForms[0].controls['genderControl'].setValue(
          student.genderId
        );
        this.membersForms[0].controls['raceControl'].setValue(
          student.raceId
        );
        this.membersForms[0].controls['ethnicityControl'].setValue(
          student.ethnicityId
        );
        this.membersForms[0].controls['isNewControl'].setValue(false);
        this.membersForms[0].controls['idControl'].setValue(student.id);
        this.needEmail = student.email == null;
        this.membersForms[0].controls['needNameControl'].setValue(student.firstName == null && student.lastName == null);

      } else {
        this.insertNewMemberToForm(student);
      }
      if (this.showPreferredDistrictOpt()) {


        this.preferredDistricControl.setValue(
          student.preferredInstitutionId
        );
        let preferredDistrict = this.institutionService.allInstutions$.value.find(
          (i) => i.id == this.preferredDistricControl.value
        );
        if (preferredDistrict) {
          this.localStorageUtil.savePreferedInstitution(this.categoryName,
            preferredDistrict
          );
          this.themeService.setInstitution(preferredDistrict);
        }
      }
    });
  }

  private insertNewMemberToForm(edu: EduFamilySurvey) {
    var needName = !edu.firstName && !edu.lastName;
    let newForm = new FormGroup({
      districtControl: new FormControl(edu.institutionId, [
        Validators.required,
      ]),
      schoolControl: new FormControl(edu.facilityId, [Validators.required]),
      afterHourCareDistrictControl: new FormControl(edu.afterHourInstitutionId? edu.afterHourInstitutionId : '0'),
      gradeControl: new FormControl(edu.unitId, [Validators.required]),
      genderControl: new FormControl(edu.genderId),
      raceControl: new FormControl(edu.raceId),
      ethnicityControl: new FormControl(edu.ethnicityId),
      isNewControl: new FormControl(false),
      idControl: new FormControl(edu.id),
      needNameControl: new FormControl(needName),
      firstNameControl: new FormControl(null, [ Validators.pattern('^[a-zA-Z ]*$')]),
      lastNameControl: new FormControl(null, [ Validators.pattern('^[a-zA-Z ]*$')])
    });
    this.addListenerToSingleControl(newForm);
    this.membersForms.push(newForm);
  }

  private matchDefaultAfterHourOption(selectedOption: any ): number {
    const defaultOptions = ['0', ''];
    return defaultOptions.includes(selectedOption) ? 0 : selectedOption;
  }

  private buildSurveys(houseHoldId: string): EduFamilySurvey[] {
    let prefferedDistrictId = this.preferredDistricControl.value;
    let surveys: EduFamilySurvey[] = [];
    this.membersForms.forEach(async (m) => {
      let s: EduFamilySurvey = new EduFamilySurvey();
      s.institutionId = m.controls['districtControl'].value;
      s.facilityId = m.controls['schoolControl'].value;
      s.afterHourInstitutionId = this.matchDefaultAfterHourOption(m.controls['afterHourCareDistrictControl'].value);
      s.unitId = m.controls['gradeControl'].value;
      s.genderId =
        m.controls['genderControl'].value == ''
          ? 0
          : m.controls['genderControl'].value;
      s.raceId =
        m.controls['raceControl'].value == ''
          ? 0
          : m.controls['raceControl'].value;
      s.ethnicityId =
        m.controls['ethnicityControl'].value == ''
          ? 0
          : m.controls['ethnicityControl'].value;
      s.houseHoldId = houseHoldId;
      s.modelAction = m.controls['isNewControl'].value
        ? PersistenceAction.INSERT
        : PersistenceAction.UPDATE;
      s.updatedBy = 'edu-user';
      s.createdBy = 'edu-user';
      s.id = m.controls['idControl'].value;
      s.preferredInstitutionId = prefferedDistrictId;
      if( m.controls['needNameControl'].value == true  ){
        if(m.controls['firstNameControl'].value && m.controls['firstNameControl'].value != ""){
          const firstName: string = m.controls['firstNameControl'].value;
          s.firstName = await this.encryptionUtil.encrypt(firstName.trim().toUpperCase());
        }
        if(m.controls['lastNameControl'].value && m.controls['lastNameControl'].value != ""){
          const lastName: string = m.controls['lastNameControl'].value;
          s.lastName = await this.encryptionUtil.encrypt(lastName.trim().toUpperCase());
        }
      }
      // needs to see if its null or not
      if (this.emailControl.value) {
        const email: string = this.emailControl.value.trim().toUpperCase();
        s.email = await this.encryptionUtil.encrypt(email);
      }
      surveys.push(s);
    });

    this.deletedSurveys.forEach((m) => {
      let s: EduFamilySurvey = new EduFamilySurvey();
      s.institutionId = m.controls['districtControl'].value;
      s.facilityId = m.controls['schoolControl'].value;
      s.afterHourInstitutionId = this.matchDefaultAfterHourOption(m.controls['afterHourCareDistrictControl'].value);
      s.unitId = m.controls['gradeControl'].value;
      s.genderId =
        m.controls['genderControl'].value == ''
          ? 0
          : m.controls['genderControl'].value;
      s.raceId =
        m.controls['raceControl'].value == ''
          ? 0
          : m.controls['raceControl'].value;
      s.ethnicityId =
        m.controls['ethnicityControl'].value == ''
          ? 0
          : m.controls['ethnicityControl'].value;
      s.houseHoldId = houseHoldId;
      s.modelAction = PersistenceAction.DELETE;
      s.updatedBy = 'edu-user';
      s.createdBy = 'edu-user';
      s.id = m.controls['idControl'].value;
      s.preferredInstitutionId = prefferedDistrictId;
      surveys.push(s);
    });
    return surveys;
  }

  private loadFormCatalogsData() {
    this.subscriptions.push(
      this.institutionService.allInstutions$.subscribe(
        (institutions) => {
          this.districts = institutions.filter((i) => i.institutionTypeId == InstitutionType.SCHOOL_DISTRICT);
          if (!this.institutionService.allInstutions$.value.find((d) => this.preferredInstution && d.id == this.preferredInstution.id)){
            this.preferredInstution = null;
          }
          if(this.preferredInstution && this.localStorageUtil.getIsInstitutionURL(this.categoryName)){
            this.preferredDistricControl.setValue(this.preferredInstution.id)
          }
        },
        (err) =>
          this.toasterService.show(
            MessageType.SYSTEM_ERROR,
            'Something went wrong. Could not load form data.'
          )
      )
    );
  }

  private newStudentForm(): FormGroup {
    return new FormGroup({
      districtControl: new FormControl('', [Validators.required]),
      schoolControl: new FormControl('', [Validators.required]),
      gradeControl: new FormControl('', [Validators.required]),
      afterHourCareDistrictControl: new FormControl(''),
      genderControl: new FormControl(''),
      raceControl: new FormControl(''),
      ethnicityControl: new FormControl(''),
      isNewControl: new FormControl(true),
      idControl: new FormControl(0),
      firstNameControl: new FormControl(null, [ Validators.pattern('^[a-zA-Z ]*$')]),
      lastNameControl: new FormControl(null, [ Validators.pattern('^[a-zA-Z ]*$')]),
      needNameControl: new FormControl(true)
    });
  }

  private addListenerToSingleControl(form: FormGroup) {
    form.controls['districtControl'].valueChanges.subscribe((val) => {
      this.updatePreferredDistrict();
      if (form.controls['districtControl'].dirty) {
        form.controls['schoolControl'].reset();
        form.controls['gradeControl'].reset();
        form.controls['schoolControl'].setValue('');
        form.controls['gradeControl'].setValue('');
      }
      form.controls['afterHourCareDistrictControl'].clearValidators();
      form.controls['afterHourCareDistrictControl'].updateValueAndValidity();
      form.controls['afterHourCareDistrictControl'].reset();
      form.controls['afterHourCareDistrictControl'].setValue('');
    });
    form.controls['schoolControl'].valueChanges.subscribe((val) => {
      form.controls['gradeControl'].reset();
      form.controls['gradeControl'].setValue('');
    });
    form.controls['afterHourCareDistrictControl'].valueChanges.subscribe((val) => {
      this.updatePreferredDistrict();
    });
  }

  private districtById(distId: number) {
    return this.districts.find((d) => distId == d.id);
  }

  private generateId() {
    var id = '';
    var char_list = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    for (var i = 0; i < 8; i++) {
      id += char_list.charAt(Math.floor(Math.random() * char_list.length));
    }
    return id;
  }
}
